<template>
  <div id="taxDiv">
    <div class="container">

      <PageTitle :title="`${$t('tax.title')} ${data.uniqueName || ''}`"></PageTitle>

      <Panel :title="$t('tax.information')">

        <div v-html="tooltipText" style="margin-bottom: 10px"></div>
        <div class="group">
          <label>{{ $t('tax.uniqueName') }}</label>
          <input type="text" v-model="data.uniqueName">
        </div>

        <div class="group">
          <LocalizedInput :title="$t('name')" :translate="data.name" />
        </div>

        <div class="group">
          <label>{{ $t('tax.type') }}</label>
          <select v-model="data.type">
            <option value="percent">{{ $t('tax.types.percent') }}</option>
            <option value="flat">{{ $t('tax.types.flat') }}</option>
          </select>
        </div>

        <div class="group">
          <label>{{ $t('tax.value') }}</label>
          <input v-model="data.value" type="number">
        </div>

      </Panel>
      <div class="footer-actions">
        <button class="save btn btn-primary" @click="save">{{ $t("save") }}</button>
      </div>

    </div>
  </div>
</template>

<script>
  import LocalizedInput from "@/components/tools/LocalizedInput";
  import { Core } from "@/core/Core";
  import PageTitle from "@/components/PageTitle";

  export default {
    name: "Tax",

    components: { LocalizedInput, PageTitle },

    data() {
      return {
        /* if a uniqueName is legacy we will not enforce the new constraints on naming */
        isLegacyUniqueName: false,
        tooltipText: [
          "A good unique name would be the location first (ex: QUEBEC)",
          "followed by the abbreviation if relevant (ex: TPS)",
          "Avoid putting 'TAX' in the name, it's redundant",
          "Avoid putting the tax amount in the name, unless you have good reason to do so"
        ].join('<br>'),
        data: {
          uniqueName: null,
          name: {
            fr: null,
            en: null
          },
          type: 'percent',
          value: 0
        }
      }
    },

    watch: {
      'data.uniqueName'(val) {
        val = typeof val === 'string' ? val.toUpperCase() : '';
        if (!this.isLegacyUniqueName) {
          val = val
            .replace(/\s/g, '_') /* replace space with underscore automatically */
            .replace(/[^A-Z\d_]/g, '') /* prevent unauthorized characters */
        }
        this.data.uniqueName = val;
      }
    },

    async mounted() {
      this.$store.state.pageTitleTranslationKey = "tax_group.title";
      this.$store.state.pageIcon = "";

      let id = this.$route.query.id;
      if (id) {
        showSpinner();
        let tax = await Core.noThrowRequest("GET", `/api/taxes/${id}`);
        hideSpinner();
        if (tax) {
          this.setTaxData(tax);
        }
      }
    },

    methods: {
      async save() {
        showSpinner();
        let tax = this.data.id
          ? await Core.noThrowRequest('PUT', `/api/taxes/${this.data.id}`, this.data)
          : await Core.noThrowRequest('POST', `/api/taxes`, this.data);
        hideSpinner();

        if (tax) {
          this.setTaxData(tax);
          toast(this.$t('save'), 'success');
          await this.$router.push(this.$router.buildContext("/taxes"));
        }
      },

      isValidUniqueName(uniqueName) {
        return typeof uniqueName === 'string'
          ? /^[A-Z\d_]+$/.test(uniqueName)
          : false;
      },

      setTaxData(data) {
        this.isLegacyUniqueName = data.id && !this.isValidUniqueName(data.uniqueName);
        Object.assign(this.data, data);
      }
    }
  }
</script>